"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONNECT_DELAY_TIME = exports.DELIMITER = exports.ERROR_MESSAGE_INDEX = exports.MAX_SERVER_REACHABLE_TIME = exports.NOOP = exports.PATH = void 0;
var PATH = '/websocket/bind';
exports.PATH = PATH;
/**
 * 等价于心跳消息
 */
var NOOP = 'noop';
exports.NOOP = NOOP;
/**
 * 分隔符
 */
var DELIMITER = '\r\n';
exports.DELIMITER = DELIMITER;
/**
 * 请求过期时间（超过这个时间没有收到任何消息视为请求过期）
 */
var MAX_SERVER_REACHABLE_TIME = 45 * 1000;
exports.MAX_SERVER_REACHABLE_TIME = MAX_SERVER_REACHABLE_TIME;
/**
 * receive 重连时间间隔
 */
var CONNECT_DELAY_TIME = 3 * 1000;
exports.CONNECT_DELAY_TIME = CONNECT_DELAY_TIME;
/**
 * 错误或者结束消息的index
 */
var ERROR_MESSAGE_INDEX = [0, -1];
exports.ERROR_MESSAGE_INDEX = ERROR_MESSAGE_INDEX;
